export const specialities = [
  {
    id: 1,
    description: "REI",
    sort: 1,
  },
  {
    id: 2,
    description: "Urologist",
    sort: 2,
  },
  {
    id: 3,
    description: "Embryologist",
    sort: 3,
  },
  {
    id: 4,
    description: "Geneticist",
    sort: 4,
  },
  {
    id: 5,
    description: "Researcher",
    sort: 5,
  },
  {
    id: 6,
    description: "Psychologist",
    sort: 6,
  },
  {
    id: 7,
    description: "Attorney",
    sort: 7,
  },
  {
    id: 8,
    description: "Genetic Counselor",
    sort: 8,
  },
  {
    id: 9,
    description: "OBGYN",
    sort: 9,
  },
  {
    id: 10,
    description: "REI Fellow",
    sort: 10,
  },
  {
    id: 11,
    description: "Fertility Navigator",
    sort: 11,
  },
  {
    id: 12,
    description: "Acupuncturist",
    sort: 12,
  },
  {
    id: 13,
    description: "Nutritionist",
    sort: 13,
  },
  {
    id: 14,
    description: "Pharmacist",
    sort: 14,
  },
  {
    id: 15,
    description: "Lab Director",
    sort: 15,
  },
  {
    id: 16,
    description: "Agency",
    sort: 16,
  },
  {
    id: 17,
    description: "Therapist",
    sort: 17,
  },
  {
    id: 18,
    description: "Egg Donor Agency",
    sort: 18,
  },
  {
    id: 19,
    description: "Surrogacy Agency",
    sort: 19,
  },
  {
    id: 20,
    description: "Vaccine Researcher",
    sort: 20,
  },
  {
    id: 21,
    description: "Epidemiologist",
    sort: 21,
  },
];
